import React, {useEffect} from 'react';
import {useTranslation} from '../../../hooks/useTranslation';
import MetricsTable from '../../Dashboard/MetricsTable';
import {useLazyMetricsCorrectiveActionsStatsQuery} from '../../../store/builder/inspections.api';

const OPEN_CORRECTIVE_ACTIONS_HEADERS = [
  {label: 'advancedMetrics.createDate', value: 'created_at', is_date: true},
  {label: 'advancedMetrics.equipmentId', value: 'equipment_title'},
  {label: 'advancedMetrics.equipmentType', value: 'equipment_type'},
  {label: 'advancedMetrics.facility', value: 'facility_name'},
  {label: 'advancedMetrics.comment', value: 'comment'},
];

const OpenCorrectiveActionsTable = ({
  body: bodyProp,
  title,
  blockClassName = 'metrics__block',
  agency,
}) => {
  const {t} = useTranslation();
  const currentFbo =
    agency != null ? +agency : +(localStorage.getItem('current-fbo') || 0) || null;

  const [getMetricsCorrectiveStats, {data: correctiveStatsData}] =
    useLazyMetricsCorrectiveActionsStatsQuery();

  useEffect(() => {
    if (bodyProp == null && currentFbo) {
      getMetricsCorrectiveStats({agency: currentFbo});
    }
  }, [bodyProp, currentFbo]);

  const body = bodyProp ?? correctiveStatsData?.open_correctives_list;

  return (
    <div className={blockClassName}>
      <MetricsTable
        headers={OPEN_CORRECTIVE_ACTIONS_HEADERS}
        body={body}
        cols='repeat(5, 1fr)'
        title={title ?? t('advancedMetrics.openCorrectiveActionsEquipment')}
        showSelect={false}
        width='w-100'
        tableHeight='metrics-middle'
        rowHeight='metrics-mid'
      />
    </div>
  );
};

export default OpenCorrectiveActionsTable;
